export default __webpack_public_path__ + "static/media/woodchuck.b78c7bcb.png";